import { render, staticRenderFns } from "./reqProduct.vue?vue&type=template&id=d985287a"
import script from "./reqProduct.vue?vue&type=script&lang=js"
export * from "./reqProduct.vue?vue&type=script&lang=js"
import style0 from "./reqProduct.vue?vue&type=style&index=0&id=d985287a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports